__turbopack_context__.v({
  "comboList": "comboList-module-scss-module__mEvZsa__comboList",
  "comboListTitle": "comboList-module-scss-module__mEvZsa__comboListTitle",
});
